export  class AuthError extends Error {
    constructor(message, response = null) {
        super(message);
        this.name = "AuthError";
        this.response = response;  // Store the entire response or just parts of it
        this.statusCode = response ? response.status : null;
    }
}
